/**
 * BFCM Timer Helper
 * Manages multiple countdown timers for Black Friday/Cyber Monday sales
 *
 * Features:
 * - Configurable timer start times from theme settings
 * - Auto-start functionality at specified time
 * - Multiple timer states (pre-sale, special sale, main sale)
 * - DOM updates for timer displays
 * - Sale state flags for conditional logic
 */

// (Removed BFCMTimerHelper class; keeping minimal helper-only implementation)

// Initialization function to be called from theme entry
export default function BFCMHelper() {
  try {
    var t = (typeof window !== 'undefined' ? window.theme : undefined);
    if (!t || !t.bfcm || !t.bfcm.enabled) return;

    function parseDateString(dateString) {
      if (!dateString || typeof dateString !== 'string') return null;
      if (dateString.includes('T')) return new Date(dateString);
      var parts = dateString.split(' ');
      if (parts.length < 2) return null;
      var d = parts[0].split('-');
      var y = parseInt(d[0], 10);
      var day = parseInt(d[1], 10);
      var m = parseInt(d[2], 10);
      var tparts = parts[1].split(':');
      var hh = parseInt(tparts[0] || '0', 10);
      var mm = parseInt(tparts[1] || '0', 10);
      var ss = parseInt((tparts[2] || '0'), 10);
      return new Date(y, (m || 1) - 1, day || 1, hh, mm, ss);
    }

    function formatTime(ms) {
      var totalSeconds = Math.max(0, Math.floor(ms / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      if (hours > 0) {
        // >= 1 hour: 1h 54M
        return (
          String(hours) + 'h ' +
          String(minutes).padStart(2, '0') + 'M'
        );
      }
      // < 1 hour: 10:30 Mins
      return (
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0') + ' Mins'
      );
    }

    function updateTimerElements(text) {
      var els1 = document.querySelectorAll('.bfcm-countdown');
      els1.forEach(function(el) {
        if(saleActive) {
          el.textContent = text;
        } else {
          el.textContent = `Live in ${text}`;
        }
      });
      var els2 = document.querySelectorAll('.bfcm-sale-text');
      els2.forEach(function(el) {
        if(saleActive) {
          el.textContent = t.bfcm.duringSaleText;
        } else {
          el.textContent = t.bfcm.preSaleText;
        }
      });
    }

    function updateTimerElementsFinal() {
      var els1 = document.querySelectorAll('.bfcm-countdown');
      els1.forEach(function(el) {
        el.textContent = '00:00 Mins';
      });
      var els2 = document.querySelectorAll('.bfcm-sale-text');
      els2.forEach(function(el) {
        el.textContent = t.bfcm.duringSaleText;
      });
    }

    function updateSaleActiveState(newState) {
      var oldState = saleActive;
      saleActive = newState;

      // Dispatch event whenever saleActive changes
      if (oldState !== saleActive) {
        console.log('BFCM: SaleActive changed from', oldState, 'to', saleActive);
        window.dispatchEvent(new CustomEvent('saleActiveChanged', {
          detail: { saleActive: saleActive }
        }));
      }

      // Update theme object
      if (t && t.bfcm) t.bfcm.saleActive = saleActive;
    }

    var saleStart = null;
    var saleEnd = null;
    var phase = null; // 'toStart' | 'toEnd'
    var saleActive = false;

    if (t.bfcm.enabled) {
      saleStart = parseDateString(t.bfcm.saleStartDate);
      saleEnd = parseDateString(t.bfcm.saleEndDate);
      console.log('BFCM: Parsed dates - Start:', saleStart, 'End:', saleEnd);
      console.log('BFCM: Raw dates - Start:', t.bfcm.saleStartDate, 'End:', t.bfcm.saleEndDate);
    }

    // If neither date is provided, there's nothing to count down to
    if (!saleStart && !saleEnd) {
      updateSaleActiveState(false);
      return;
    }

    var now = new Date();
    console.log('BFCM: Current time:', now.toISOString());

    // Decide initial phase
    if (saleStart && now < saleStart) {
      phase = 'toStart';
      updateSaleActiveState(false);
      console.log('BFCM: Initial phase set to toStart - counting down to start');
    } else if (saleEnd && now < saleEnd) {
      phase = 'toEnd';
      updateSaleActiveState(!!(saleStart && now >= saleStart));
      console.log('BFCM: Initial phase set to toEnd - counting down to end');
    } else {
      // Both dates are in the past or missing, do not start
      console.log('BFCM: No valid dates or all dates in past - not starting timer');
      updateSaleActiveState(false);
      setTimeout(() => {
        updateTimerElementsFinal();
      }, 1500)
      return;
    }

    if (window.bfcmTimerInterval) {
      clearInterval(window.bfcmTimerInterval);
      window.bfcmTimerInterval = null;
    }

    function updateTimer() {
      var now = new Date();
      var targetDate;
      var diff;

      console.log('BFCM Timer tick - Phase:', phase, 'SaleActive:', saleActive, 'Now:', now.toISOString());

      if (phase === 'toStart') {
        // Before sale start, sale is not active
        if (saleActive !== false) {
          updateSaleActiveState(false);
        }
        if (saleStart && now < saleStart) {
          targetDate = saleStart;
          diff = targetDate - now;
          if (diff <= 0) diff = 0;
          updateTimerElements(formatTime(diff));
          return;
        }
        // We have reached/passed the start; switch to counting down to end if available
        if (saleEnd && now < saleEnd) {
          phase = 'toEnd';
          updateSaleActiveState(true);
          // Continue to the toEnd phase logic below
        } else {
          updateTimerElementsFinal();
          updateSaleActiveState(false);
          if (window.bfcmTimerInterval) {
            clearInterval(window.bfcmTimerInterval);
            window.bfcmTimerInterval = null;
          }
          return;
        }
      }

      if (phase === 'toEnd') {
        if (saleEnd && now < saleEnd) {
          targetDate = saleEnd;
          diff = targetDate - now;
          if (diff <= 0) diff = 0;
          updateTimerElements(formatTime(diff));
          if (saleActive !== true) {
            updateSaleActiveState(true);
          }
        } else {
          // End time reached - stop timer
          updateTimerElementsFinal();
          updateSaleActiveState(false);
          if (window.bfcmTimerInterval) {
            clearInterval(window.bfcmTimerInterval);
            window.bfcmTimerInterval = null;
          }
        }
      }
    }

    // Initial update
    updateTimer();

    // Update every second
    window.bfcmTimerInterval = setInterval(updateTimer, 1000);

  } catch (e) {
    if (window && window.console && console.error) {
      console.error('BFCMHelper error:', e);
    }
  }
}
